import { render, staticRenderFns } from "./bankpay.vue?vue&type=template&id=939fb530&scoped=true&"
import script from "./bankpay.vue?vue&type=script&lang=js&"
export * from "./bankpay.vue?vue&type=script&lang=js&"
import style0 from "./bankpay.vue?vue&type=style&index=0&id=939fb530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939fb530",
  null
  
)

export default component.exports